import axios from "../axios";
import { notifyDanger, notifySuccess } from "./customFn";
import Swal from 'sweetalert2'

const setAllPrograms = (data) => {
  return {
    type: "SET_ALL_PROGRAMS",
    payload: data,
  };
};

export const asyncGetAllPrograms = (query) => {
  return (dispatch) => {
    const url = "/course/get-all/program";

    const config = {
      params: query,
      headers: {
        "X-Client-App": "metbrains",
      },
    };
    axios
      .get(url, config)
      .then((res) => {
        const { data } = res.data;
        dispatch(setAllPrograms(data));
      })
      .catch((err) => {
        console.log(err);
      });
  };
};

export const setAllCourses = (data) => {
  return {
    type: "SET_ALL_COURSES",
    payload: data,
  };
};

export const asyncGetAllCourses = (query) => {
  return (dispatch) => {
    const url = "/course/get-all/program";

    const config = {
      params: query,
      headers: {
        "X-Client-App": "metbrains",
      },
    };
    axios
      .get(url, config)
      .then((res) => {
        const { data } = res.data;
        dispatch(setAllCourses(data));
      })
      .catch((err) => {
        console.log(err);
      });
  };
};

export const setTotalCourses = (data) => {
  return {
    type: "SET_ALL_TOTAL_COURSES",
    payload: data,
  };
};
export const asyncGetTotalCourses = (query) => {
  return (dispatch) => {
    const url = "/course/get-all/program";
    const config = {
      headers: {
        "X-Client-App": "metbrains",
      },
    }
    axios
      .get(url)
      .then((res) => {
        const { data } = res.data;
        dispatch(setTotalCourses(data));
      })
      .catch((err) => {
        console.log(err);
      });
  };
};

export const setProgramData = (data) => {
  return {
    type: "SET_PROGRAM_DATA",
    payload: data,
  };
};

export const asyncGetProgramById = (ID , setIsLoading) => {
  return (dispatch) => {
    const url = `/course/page_data/${ID}/`;
    axios
      .get(url)
      .then((res) => {
        const { data } = res.data;
        dispatch(setProgramData(data));
        if(setIsLoading){
          setIsLoading(false)
        }
      })
      .catch((err) => {
        console.log(err);
        if(setIsLoading){
          setIsLoading(false)
        }
      });
  };
};

export const setCourseData = (data) => {
  return {
    type: "SET_COURSE_DATA",
    payload: data,
  };
};

export const asyncGetCourseData = (ID) => {
  return (dispatch) => {
    const url = `/course/mycourse/${ID}`;

    axios
      .get(url)
      .then((res) => {
        const { data } = res.data;
        dispatch(setCourseData(data));
      })
      .catch((err) => {
        console.log(err);
      });
  };
};

export const setPreviewVideos = (data) => {
  return {
    type: "SET_ALL_PREVIEW_VIDEOS",
    payload: data,
  };
};

export const asyncGetPreviewVideos = (ID) => {
  return (dispatch) => {
    const url = `/course/mycourse/preview-video/${ID}`;

    axios
      .get(url)
      .then((res) => {
        const { data } = res.data;
        dispatch(setPreviewVideos(data));
      })
      .catch((err) => {
        console.log(err);
      });
  };
};

export const asyncPostProgramQuery = (data, initialState) => {
  return (dispatch) => {
    const url = `/course/query/`;

    axios
      .post(url, data)
      .then((res) => {
        const { message } = res.data;
        notifySuccess(message);
        initialState();
      })
      .catch((err) => {
        console.log(err);
      });
  };
};

export const asyncPostBootcampData = (
  data,
  initialState,
  navigate,
  setIsLoading
) => {
  return (dispatch) => {
    const url = `/course/post-bootcamp/`;

    axios
      .post(url, data)
      .then((res) => {
        const { message } = res.data;
        notifySuccess(message);
        initialState();
        setIsLoading(false);
        navigate("/");
        localStorage.removeItem("formData")
      })
      .catch((err) => {
        setIsLoading(false);
        notifyDanger(err.response.data.message || "some error occured ")
        console.log(err);
        localStorage.removeItem("formData")

      });
  };
};


export const asyncPostMasterclassData = (
  data,
  initialState,
  navigate,
  setIsLoading,
  isPayment
) => {
  return (dispatch) => {
    const url = `/course/post-masterclass/`;
    const f_dt = isPayment ? {...data, payment_captured: true} : data;
    axios
      .post(url, f_dt)
      .then((res) => {
        const { message } = res.data;
        notifySuccess(message);
        initialState();
        setIsLoading(false);
        localStorage.removeItem("formData")
        navigate(`/na6nsd/masterclass-link?slug=${data.slug}`);
      })
      .catch((err) => {
        setIsLoading(false);
        notifyDanger(err.response.data.message || "some error occured ")
        console.log(err);
        localStorage.removeItem("formData")
      });
  };
};